import { alpha, styled } from '@mui/material/styles'
import { Button, ButtonProps } from '@carto/meridian-ds/components'

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.brand.appBarContrastText,
  borderColor: alpha(theme.palette.brand.appBarContrastText, 0.4),

  '&:hover, &:active': {
    backgroundColor: alpha(theme.palette.brand.appBarContrastText, 0.12)
  },
  '&:disabled': {
    color: alpha(theme.palette.brand.appBarContrastText, 0.25),
    borderColor: alpha(theme.palette.brand.appBarContrastText, 0.25),

    '& .MuiTypography-root': {
      color: alpha(theme.palette.brand.appBarContrastText, 0.25)
    }
  },

  '&.MuiIconButton-root svg path': {
    fill: theme.palette.brand.appBarContrastText
  }
}))

function HeaderButton({ ...buttonProps }: ButtonProps) {
  return (
    <StyledButton {...buttonProps} variant="outlined" color="inherit">
      {buttonProps.children}
    </StyledButton>
  )
}

export default HeaderButton
